/*
 * @Author: Damon
 * @Date: 2020-09-21 10:58:33
 * @LastEditors: damon
 * @LastEditTime: 2022-06-07 15:04:04
 * @Description: file content
 */
/* eslint-disable import/first */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';

import './icons'; // icon
import '@/styles/index.scss'; // global css
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import i18n from '@/assets/i18n/index';
import router from './router';
import store from './store';

import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';
import * as filters from './filters'; // global filters
import VueClipboard from 'vue-clipboard2';
import EleUploadVideo from 'vue-ele-upload-video';

// import { VueJsonp } from 'vue-jsonp';

// 全局引入

Vue.component(EleUploadVideo.name, EleUploadVideo);

Vue.config.productionTip = false;

Vue.use(ElementUI);

Vue.use(VueClipboard);

// Vue.use(VueJsonp);

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */

// const { mockXHR } = require('../mock');

// mockXHR();

const requireComponent = require.context(
  // 其组件目录的相对路径
  './components',
  // 是否查询其子目录
  true,
  // 匹配基础组件文件名的正则表达式
  /D[A-Z]\w+\.(vue|js)$/,
);

requireComponent.keys().forEach((fileName) => {
  // 获取组件配置
  const componentConfig = requireComponent(fileName);

  // 获取组件的 PascalCase 命名
  const componentName = upperFirst(
    camelCase(
      // 获取和目录深度无关的文件名
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, ''),
    ),
  );

  // 全局注册组件
  Vue.component(
    componentName,
    // 如果这个组件选项是通过 `export default` 导出的，
    // 那么就会优先使用 `.default`，
    // 否则回退到使用模块的根。
    componentConfig.default || componentConfig,
  );
});

// register global utility filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js